import type { HistoryStamp } from '@kontor/shared';

const stampFormat = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Berlin' });

/** „Erstellt von Anna Beispiel am 14.10.2026 um 09:12 Uhr“. Ohne Namen (Integration oder gelöschter Benutzer) steht nur der Zeitpunkt. */
export function HistoryNote({ verb, stamp }: { verb: string; stamp: HistoryStamp | null | undefined }) {
  if (!stamp) return null;
  const when = stampFormat.format(new Date(stamp.at)).replace(', ', ' um ');
  return (
    <span className="history-note">
      {verb}
      {stamp.name ? ` von ${stamp.name}` : ''} am {when} Uhr
    </span>
  );
}
